import React, {FC} from 'react'

import cn from 'classnames/bind'
import {observer} from 'mobx-react-lite'

import IconDelete from 'assets/icons/delete.svg'
import IconPlus from 'assets/icons/plus.svg'
import Checkbox from 'components/elements/fields/Checkbox'
import FieldLabel from 'components/elements/fields/FieldLabel'
import MobxTextArea from 'components/elements/fields/MobxTextArea'
import MobxTextInput from 'components/elements/fields/MobxTextInput'
import {Col, Row} from 'components/elements/grid'
import InvoiceItemStore from 'src/models/Invoice/InvoiceItem.store'
import {useInvoiceStore, useRootStore} from 'src/utils/contexts/RootStore.context'

import s from './FieldsInvoiceTable.module.scss'

const cx = cn.bind(s)

interface IFieldsInvoiceTableProps {
	className?: string
}

const FieldsInvoiceTable: FC<IFieldsInvoiceTableProps> = ({className}) => {
	const rootStore = useRootStore()
	const freeInvoiceStore = useInvoiceStore()

	const addItem = () => {
		freeInvoiceStore.items.push(new InvoiceItemStore(rootStore))
	}

	const onRemoveLastItem = () => {
		if (freeInvoiceStore.items.length === 1) return
		freeInvoiceStore.items.pop()
	}

	return (
		<div className={cx('wrapper', className)}>
			<ul className={cx('items')}>
				{freeInvoiceStore.items.map((storeItem, idx) => (
					<li className={cx('items__item')} key={idx} data-testid="item">
						<Item store={storeItem} />
						<Col md={12} lg={{offset: 1, span: 10}} xl={{offset: 2, span: 8}}>
							<hr />
						</Col>
					</li>
				))}
			</ul>
			<Row>
				<Col md={6} lg={{offset: 1, span: 5}} xl={{offset: 2, span: 4}}>
					<div className={cx('btn-set')}>
						<button
							className={cx('btn', 'btn--add')}
							type="button"
							title="Add Item"
							data-testid="add-item"
							onClick={addItem}>
							<IconPlus /> <span>Add item</span>
						</button>
						<button
							className={cx('btn', 'btn--delete')}
							type="button"
							title="Remove Item"
							onClick={onRemoveLastItem}>
							<IconDelete /> <span>Delete</span>
						</button>
					</div>
				</Col>
				<Col md={12} lg={{offset: 1, span: 10}} xl={{offset: 2, span: 8}}>
					<hr />
				</Col>
			</Row>
		</div>
	)
}

FieldsInvoiceTable.displayName = 'FieldsInvoiceTable'

export default observer(FieldsInvoiceTable)

const Item: FC<{store: InvoiceItemStore}> = observer(({store}) => {
	return (
		<div className={cx('item')}>
			<Row>
				<Col md={6} lg={{offset: 1, span: 5}} xl={{offset: 2, span: 4}}>
					<MobxTextInput
						wrapperClassName={cx('mt-2')}
						label="description"
						store={store}
						name="description"
						placeholder="Item Description"
					/>
					<MobxTextArea
						wrapperClassName={cx('mt-1')}
						className={cx('details')}
						store={store}
						name="details"
						placeholder="Additional details"
					/>
				</Col>
				<Col md={6} lg={{offset: 0, span: 5}} xl={{offset: 0, span: 4}}>
					<div className={cx('rate-fields', 'mt-2')}>
						<MobxTextInput
							className={cx('rate-fields__field', 'ta-right')}
							label="Rate"
							store={store}
							name="rate"
							shouldHandleOldValue
							isNumber
							isFormatText
							placeholder="0.00"
						/>
						<MobxTextInput
							className={cx('rate-fields__field', 'ta-right')}
							label="QTY"
							store={store}
							name="qty"
							shouldHandleOldValue
							isNumber
							isFormatText
							placeholder="0.00"
						/>
						<FieldLabel
							className={cx('rate-fields__field', 'amount')}
							label="amount"
							required={false}>
							<span className={cx('amount__content')}>
								$<span data-testid="amount">{store.amount}</span>
							</span>
						</FieldLabel>

						<Checkbox
							classNameWrapper={cx('tax')}
							label="TAX"
							type="checkbox"
							value={store.withTax === true}
							onChange={(e) => {
								store.withTax = e.target.checked
							}}
						/>
					</div>
				</Col>
			</Row>
		</div>
	)
})
